module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av182-2a1e9dba0f2ad09b3ec955d4437dc2a0.jpg";